export default "__VITE_ASSET__Bw4$4wd0__"